import './components/form-elements';
import './print-events.js';
import programtypeTermSelection from './components/programtype-term-selection.js';
import programGeneralTermSelection from './components/program-general-term-selection.js';
import openHouseFilters from './components/open-house-filters.js';
import ArchiveProgramsPage from './components/archive-programs-page.js';
import facetWPModifications from './components/facetwp-modifications.js';
import generalACFModifications from './components/general-acf-modifications.js';
import skanegySliders from './components/sliders.js';
import './components/video-placeholder.js';
import ReadMore from './read-more.js';

// Instantiate the program selection class as long as the ACF global exists.
document.addEventListener( 'DOMContentLoaded', () => {
	if ( typeof acf !== 'undefined' ) {
		new programtypeTermSelection();
		new programGeneralTermSelection();
		new generalACFModifications();
	}

	new skanegySliders();
	new ArchiveProgramsPage();
	new ReadMore();
} );

window.onload = () => {
	new	openHouseFilters();
};

// Stuff that only sets up other event listeners
new facetWPModifications();
